import React, {Component, Fragment} from 'react'
import autobind from 'autobind-decorator'
import CCLCheckbox from "./CCLCheckbox";

const CCL_COMMERCIALS = [
  {value:1, label:'예' },
  {value:2, label:'아니오' },
];

const CCL_DERIVES = [
  {value:1, label:'예' },
  {value:2, label:'아니오' },
  {value:3, label:'동일한 설정 적용시 허락' },
];

class CCLButton extends Component {

  @autobind
  handleChangeUse(e) {
    const { onChange } = this.props
    const value = e.target.checked? 1 : 0;
    onChange(value, value)
  }

  render() {
    const { cclDerive, cclCommercial, onChange } = this.props
    const useCCL = cclDerive > 0 && cclCommercial > 0

    return (
      <div className="ccl_editor">
        <div className="wrap_ccl">
          {!useCCL &&
            <span className="txt_ccl">CCL 설정</span>
          }
          {useCCL &&
            <span className="mce-ico ico_ccl01">저작물 사용허가</span>
          }
          {cclCommercial == 2 &&
            <span className="mce-ico ico_ccl02">상업적 허용 안함</span>
          }

          {cclDerive == 2 &&
            <span className="mce-ico ico_ccl03">콘텐츠 변경 허용 안함</span>
          }

          {cclDerive == 3 &&
            <span className="mce-ico ico_ccl04">동일한 설정 적용시 허락</span>
          }
        </div>

        <div className="layer_info" style={{top:"36px",right:"-23px"}}>
          <div className="inner_layer">
            <div className="inp_item">
              <label htmlFor="ccl" className="form-field">
                <input
                  type="checkbox" id="ccl"
                  className="form-checkbox klink-linknew"
                  checked={cclDerive > 0 && cclCommercial > 0}
                  onChange={this.handleChangeUse}
                />
                <span className="checkbox-text">저작물 사용 허가를 표시합니다.</span>
              </label>
            </div>

            {useCCL &&
              <Fragment>
                <dl className="info_ccl">
                  <dt>상업적 이용</dt>
                  <dd>
                    {CCL_COMMERCIALS.map(item =>
                      <CCLCheckbox
                        key={item.value}
                        prefix={'cclCommercial'}
                        item={item}
                        value={cclCommercial}
                        useWrap={false}
                        onChange={value => onChange(value, cclDerive)}
                      />
                    )}
                  </dd>
                </dl>
                <dl className="info_ccl">
                  <dt>콘텐츠 변경</dt>
                  <dd>
                    {CCL_DERIVES.map(item =>
                      <CCLCheckbox
                        key={item.value}
                        prefix={'cclDerive'}
                        item={item}
                        value={cclDerive}
                        useWrap={item.value == 3}
                        onChange={value => onChange(cclCommercial, value)}
                      />
                    )}
                  </dd>
                </dl>
              </Fragment>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default CCLButton
